import template from './loggias-count.jade';

export default angular.module('cian.addForm.loggiasCount', []).directive('cianAfAboutObjectLoggiasCount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = [
      {
        value: undefined,
        text: 'Нет',
      },
      ...[1, 2, 3, 4].map(n => ({ value: n, text: n })),
    ];

    if (!this.ad.loggiasCount) {
      this.ad.loggiasCount = this.items[0].value;
    }
  },
  controllerAs: 'loggiasCount',
  template,
})).name;
